export default __webpack_public_path__ + "static/media/cyanEclipse.15e1cf63.png";